import React from 'react'

const LoadingPage = (): React.JSX.Element => {
  return <div>Cargando...</div>
}
export default LoadingPage
